import * as React from 'react';
import {FormattedMessage} from "react-intl";
import {P} from "@atoms/Text/P";
import {SiteSpecificContent} from "@atoms/SiteSpecificContent";
import {ReadMore} from "@atoms/LinksAndButtons/ReadMore";
import {getFormattedMessage} from "features/services/utils/language-helper";
import {SITE_URLS} from "features/search/constants";
import {useAuth} from "features/authentication/hooks/useAuth";
import {ContactCard} from "@molecules/ContactCard";
import {RealEstateAgent} from "features/template/viewModels/ResidenceStage";

import './style.scss';
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel} from 'features/ui/enums';

interface Props {
    stageName: string;
    className?: string;
    premises?: boolean;
    agent?: RealEstateAgent;
}

export const InterestFormDone : React.FunctionComponent<Props> = ({className, stageName, premises, agent}) => {
    const {user} = useAuth();

    const renderContactCard = () => {
        if (!agent || premises) return null;

        return (
            <>
                <P>
                    <strong>
                        <FormattedMessage id="jm.components.InterestForm.mvh" />
                    </strong>
                </P>
                <ContactCard
                    name={agent.name}
                    title={agent.title}
                    company={agent.company}
                    phone={agent.phone}
                    mail={agent.email}
                    hideImage
                />
            </>
        );
    };

    return (
        <div className={`interest-form ${className}`} data-test-id="interest-form">
            <div className="interest-form__content">
                <div className="interest-form__done" data-test-id="interest-form-done">
                    <Headline level={HeadlineLevel.H3}>
                        <FormattedMessage id="jm.components.InterestForm.thankYou" />
                    </Headline>

                    <Headline level={HeadlineLevel.H4}>{stageName}</Headline>

                    {premises ?
                        <P>
                            <FormattedMessage id="jm.components.InterestForm.thankYouDescriptionPremises" />
                        </P> :
                        <P>
                            <SiteSpecificContent notChildSites>
                                <FormattedMessage id="jm.components.InterestForm.thankYouDescription" />
                            </SiteSpecificContent>
                            <SiteSpecificContent showOnSeniorGarden>
                                <FormattedMessage id="jm.components.InterestForm.thankYouDescriptionSeniorgarden" />
                            </SiteSpecificContent>
                            <SiteSpecificContent showOnBoratt>
                                <FormattedMessage id="jm.components.InterestForm.thankYouDescriptionBoratt" />
                            </SiteSpecificContent>
                        </P>
                    }

                    {user && !premises &&
                        <P>
                            <FormattedMessage id="jm.components.InterestForm.thankYouSeeInterest" />
                        </P>
                    }

                    {!user && !premises &&
                        <P>
                            <FormattedMessage id="jm.components.InterestForm.thankYouCreateAccount" /><br />
                            <ReadMore
                                text={getFormattedMessage('jm.components.InterestForm.thankYouCreateAccountLink')}
                                link={SITE_URLS.createAccount}
                            />
                        </P>
                    }

                    {renderContactCard()}
                </div>
            </div>
        </div>
    );
};
